import { appGetState } from 'legacy/lut/store'

import { IFilter } from 'core-components/types'
import { IDataProviderFilter } from 'core-components/types'
import { getTokens } from 'core/classes/helpers/StorageHelper'
import { proxy } from 'core/classes/helpers/UrlHelper'
import { HttpHeaders, Rest } from 'core/classes/http'

export const fetchKeyInitiatives = async (filter: IDataProviderFilter) => {
  const url = proxy('/webservice/197/sp/v4/spJBPKeyInitiatives/call')

  const filters = filter.filters as IFilter[]
  const fYear = filters.find((f) => f.field === 'FYear')?.value
  const programType = filters.find((f) => f.field === 'ProgramType')?.value
  const partnerId = filters.find((f) => f.field === 'PartnerId')?.value

  if (fYear && programType) {
    const {
      app: { ownerId },
    } = appGetState()
    const [accessToken] = getTokens(ownerId)

    const payload = {
      'p.PartnerId': partnerId,
      'p.FYear': fYear,
      'p.ProgramType': programType,
    }

    const headers = new HttpHeaders()

    if (accessToken) {
      headers.add('Authorization', `Bearer ${accessToken}`)
    }
    const response = await Rest.post({ url, payload, headers })
    if (response && response.Data) {
      return { Data: response.Data }
    }
  }
  return { Data: [] }
}
